import { StreamData } from 'types/streamData'
import { isRightToLeftText } from 'utils/rtlTextUtil'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const isTitleRtlResolver: FieldResolver = (metadata: Metadata) =>
  ({
    isTitleRtl: metadata.isDeleted() ? undefined : isRightToLeftText(metadata.getTitle())
  } as StreamData)

export default isTitleRtlResolver
